module.exports = __webpack_public_path__ + "static/tools-mrr-calculator-43ae6e9cf3eb9f101a410bca9e9506ac.svg";